import { METAL_NOTICE } from '../components/JewelleryMetalNotice';

// v3_fix_issues #11 - a plain Terms & Conditions page, linked from the footer of every vertical.
// v3_fix_issues #9 - the "duplicate 1-gram jewellery only" disclaimer is stated here in full.
export default function Terms() {
  return (
    <div className="py-4" style={{ maxWidth: 820 }}>
      <h3 className="mb-3">Terms &amp; Conditions</h3>
      <p className="text-muted small">Last updated {new Date().getFullYear()}. These terms govern your use of the RentalVerse platform.</p>

      <h5 className="mt-4">1. The platform's role</h5>
      <p>RentalVerse is a marketplace that connects people who want to rent items with the owners
        who list them. Each rental is a contract between the customer and the listing owner.
        RentalVerse facilitates discovery, booking, payments, delivery coordination and support,
        but is not itself the owner of the listed items unless explicitly stated.</p>

      <h5 className="mt-4">2. Jewellery authenticity</h5>
      <p>{METAL_NOTICE}</p>

      <h5 className="mt-4">3. Bookings, pricing and the platform fee</h5>
      <p>Prices, the security deposit and the delivery charge are shown before you confirm a
        booking. A non-refundable platform fee is charged on top of the rental amount. The owner
        receives their earnings after the rental is completed and the item is returned in good
        condition.</p>

      <h5 className="mt-4">4. Security deposit</h5>
      <p>Where a deposit applies, it is held for the duration of the rental and released once the
        item is returned and checked. Part or all of it may be withheld to cover damage, loss or a
        late return, on the published schedule.</p>

      <h5 className="mt-4">5. Cancellations and refunds</h5>
      <p>Free cancellation is available up to the owner's published refund window before the rental
        starts. After that, a portion of the rental amount is forfeited on a published schedule.
        The exact terms for a listing are shown on its page before you book. The platform fee is
        never refunded.</p>

      <h5 className="mt-4">6. Delivery and returns</h5>
      <p>Where delivery is arranged through the platform, a delivery partner collects the item from
        the owner and hands it to you, and collects it again at the end of the rental. You are
        responsible for the item between handover and return.</p>

      <h5 className="mt-4">7. Cash on delivery</h5>
      <p>Where an owner offers cash on delivery, you pay the delivery partner in cash on handover.
        A receipt reference is recorded against your booking.</p>

      <h5 className="mt-4">8. Your responsibilities</h5>
      <p>Use rented items lawfully and with reasonable care, provide accurate information, and
        return items on time and in the condition you received them.</p>

      <h5 className="mt-4">9. Liability</h5>
      <p>To the extent permitted by law, RentalVerse is not liable for disputes between customers
        and owners beyond the payment, deposit and settlement handling described above.</p>

      <h5 className="mt-4">10. Data</h5>
      <p>We process the information you provide to operate bookings, deliveries, payments and
        support, and to contact you about your requests. We do not sell your personal data.</p>

      <h5 className="mt-4">11. Contact</h5>
      <p>For questions about these terms, use the "Request a Demo" or support options in the
        footer.</p>
    </div>
  );
}
